import { AppStoreBadges } from "../components/AppStoreBadges";
import { Container } from "../components/Container";
import { Logo } from "../components/Logo";

export function WaitlistEnded() {
  return (
    <main className="min-h-screen bg-brand-500">
      <Container className="flex min-h-screen flex-col items-center justify-center py-16 text-center">
        <Logo height={48} className="mb-8 h-12 w-auto" />

        <div className="mx-auto max-w-lg rounded-3xl bg-white p-8 shadow-xl dark:bg-bg-base">
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-brand-500">
            Waitlist Closed
          </p>
          <h1 className="text-3xl font-bold tracking-tight text-text-heading sm:text-4xl">
            The wait is over!
          </h1>
          <p className="mt-4 text-base leading-7 text-text-muted">
            Our waitlist campaign has ended. ALBAVOX is now available for download!
            Get the app and start exploring Albania and the Balkans today.
          </p>

          <div className="mt-8">
            <AppStoreBadges className="justify-center" />
          </div>

          <p className="mt-6 text-sm text-text-muted">
            Thank you for your interest in ALBAVOX!
          </p>
        </div>
      </Container>
    </main>
  );
}
